import styled from 'styled-components';
import OuterLink from '../Link/OuterLink';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const ContactUsCustomComponent = styled.div `
  position: absolute;
  bottom: 0;

  height: ${({ isVisible }) => (isVisible ? '28rem' : '0')};
  width: 100%;

  transition: height 0.3s ease;

  padding: ${({ isVisible }) => (isVisible ? '2.5rem 2.4rem 3.4rem' : '0')};

  border-radius: ${({ theme }) => theme.borderRadius.high};
  /* border-top-right-radius: ${({ theme }) => theme.borderRadius.high}; */

  background-color: ${({ theme }) => theme.colors.surface.default};

  box-shadow: 0px -6px 74px 0px rgba(0, 0, 0, 0.11);
  backdrop-filter: blur(2px);
`;
export const CustomLink = styled(OuterLink) `
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 5.8rem;
  width: 100%;

  margin-bottom: 1.4rem;
  padding: 0 1.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};

  background-color: ${({ theme }) => theme.colors.interactive.secondaryDisabled};
`;
export const ZendeskChatButton = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 5.8rem;
  width: 100%;

  margin-bottom: 1.4rem;
  padding: 0 1.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};

  background-color: ${({ theme }) => theme.colors.interactive.secondaryDisabled};

  cursor: pointer;
`;
export const ContactIconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  width: 4.4rem;
  height: 4.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.text.interactive};
`;
export const ContactTextWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const IconWrapper = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 1rem;

  width: 3.2rem;
  height: 3.2rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.surface.default};
`;
export const IconTitleWrapper = styled.div `
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=styles.js.map